import React from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class FabWithText extends React.Component {
  render() {
    const {
      classes,
      action,
      label,
      icon,
      ariaLabel,
      wrap,
      small,
      iconRight,
      filled,
    } = this.props;

    const Icon = icon;

    const fabClass = filled ? classes.fabFilled : classes.fab;

    const fabIcon = (
      <Fab
        className={
          wrap
            ? `${fabClass} ${classes.fabWrap}`
            : small
            ? `${fabClass} ${classes.fabSmall}`
            : fabClass
        }
        aria-label={ariaLabel ? ariaLabel : label}
        component="div"
        size="medium"
      >
        <Icon />
      </Fab>
    );

    return (
      <div
        className={
          small ? `${classes.root} ${classes.rootSmall}` : classes.root
        }
      >
        <Button
          onClick={action}
          className={
            wrap
              ? `${classes.buttonCreate} ${
                  filled ? classes.buttonCreateFilled : ''
                } ${classes.buttonWrap}`
              : small
              ? `${classes.buttonCreate} ${
                  filled ? classes.buttonCreateFilled : ''
                } ${classes.buttonCreateSmall}`
              : `${classes.buttonCreate} ${
                  filled ? classes.buttonCreateFilled : ''
                }`
          }
        >
          {!iconRight && fabIcon}
          <span
            className={
              wrap
                ? classes.buttonInnerWrap
                : iconRight
                ? classes.buttonInnerRight
                : classes.buttonInner
            }
          >
            {label}
          </span>
          {iconRight && fabIcon}
        </Button>
      </div>
    );
  }
}

FabWithText.propTypes = {
  classes: PropTypes.object.isRequired,
  action: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
  wrap: PropTypes.bool,
  small: PropTypes.bool,
  iconRight: PropTypes.bool,
};

FabWithText.defaultProps = {
  wrap: false,
  small: false,
};

export default withStyles(styles)(FabWithText);
